import { useState } from "react";

export function Citations() {
	return (
		<div className="w-full flex justify-center px-4 pt-6">
			<div className="flex flex-col gap-4 w-full max-w-6xl min-w-0">
				<CitationAccordion
					title="📘 Citation"
					defaultOpen={false}
				>
					<pre className="p-3 rounded-lg overflow-x-auto text-left text-sm text-gray-400 w-full min-w-0" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
{`@inproceedings{garciagasulla2025turtleunifiedevaluationllms,
      title={TuRTLe: A Unified Evaluation of LLMs for RTL Generation},
      author={Dario Garcia-Gasulla and Gokcen Kestor and Emanuele Parisi and Miquel Albert\\'i-Binimelis and Cristian Gutierrez and Razine Moundir Ghorab and Orlando Montenegro and Bernat Homs and Miquel Moreto},
      booktitle = {Proceedings of the 2025 ACM/IEEE International Symposium on Machine Learning for CAD},
      series = {MLCAD '25}
      year={2025},
      publisher = {Association for Computing Machinery},
      address = {New York, NY, USA},
      location = {Santa Cruz, CA, USA},
      url={https://arxiv.org/abs/2504.01986},
      }`}
					</pre>
					<pre className="p-3 rounded-lg overflow-x-auto text-left text-sm text-gray-400 w-full min-w-0" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
{`@article{10.1145/3831369,
	author = {Alberti-Binimelis, Miquel and Gutierrez-Gomez, Cristian and Garcia-Gasulla, Dario and Parisi, Emanuele and Moundir Ghorab, Razine and Montenegro, Orlando and Homs, Bernat and Moreto, Miquel and Kestor, Gokcen},
	title = {Revisiting TuRTLe: A Comprehensive Evaluation of LLMs for RTL Generation},
	year = {2026},
	publisher = {Association for Computing Machinery},
	address = {New York, NY, USA},
	issn = {1084-4309},
	url = {https://doi.org/10.1145/3831369},
	doi = {10.1145/3831369},
	note = {Just Accepted},
	journal = {ACM Trans. Des. Autom. Electron. Syst.},
	month = jul,
	keywords = {Large Language Models (LLMs), Benchmarking, Computer-aided design (CAD)}
}`}
					</pre>
				</CitationAccordion>

				<CitationAccordion
					title="References"
					defaultOpen={false}
				>
					<div className="p-2 rounded-lg text-left text-sm text-gray-300 space-y-3 w-full min-w-0" style={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>
						<p className="break-words">• Claire Wolf and the YosysHQ contributors. Yosys Open SYnthesis Suite. <a href="https://yosyshq.net/yosys/" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300 underline">https://yosyshq.net/yosys/</a></p>
						<p className="break-words">• Code Generation LM Evaluation Harness by the BigCode project</p>
						<p className="break-words">• Williams, S. Icarus Verilog [Computer software]. <a href="https://github.com/steveicarus/iverilog" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300 underline">https://github.com/steveicarus/iverilog</a></p>
						<p className="break-words">• Snyder, W., Wasson, P., Galbi, D., & et al. Verilator [Computer software]. <a href="https://github.com/verilator/verilator" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300 underline">https://github.com/verilator/verilator</a></p>
						<p className="break-words">• <strong>RTL-Repo:</strong> Allam and M. Shalan, "Rtl-repo: A benchmark for evaluating llms on large-scale rtl design projects," in 2024 IEEE LLM Aided Design Workshop (LAD). IEEE, 2024, pp. 1–5.</p>
						<p className="break-words">• <strong>VeriGen:</strong> S. Thakur, B. Ahmad, H. Pearce, B. Tan, B. Dolan-Gavitt, R. Karri, and S. Garg, "Verigen: A large language model for verilog code generation," ACM Transactions on Design Automation of Electronic Systems, vol. 29, no. 3, pp. 1–31, 2024.</p>
						<p className="break-words">• <strong>VerilogEval (I):</strong> M. Liu, N. Pinckney, B. Khailany, and H. Ren, "Verilogeval: Evaluating large language models for verilog code generation," in 2023 IEEE/ACM International Conference on Computer Aided Design (ICCAD). IEEE, 2023, pp. 1–8.</p>
						<p className="break-words">• <strong>VerilogEval (II):</strong> N. Pinckney, C. Batten, M. Liu, H. Ren, and B. Khailany, "Revisiting VerilogEval: A Year of Improvements in Large-Language Models for Hardware Code Generation," ACM Trans. Des. Autom. Electron. Syst., feb 2025. <a href="https://doi.org/10.1145/3718088" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300 underline">https://doi.org/10.1145/3718088</a></p>
						<p className="break-words">• <strong>RTLLM:</strong> Y. Lu, S. Liu, Q. Zhang, and Z. Xie, "Rtllm: An open-source benchmark for design rtl generation with large language model," in 2024 29th Asia and South Pacific Design Automation Conference (ASP-DAC). IEEE, 2024, pp. 722–727.</p>
					</div>
				</CitationAccordion>
			</div>
		</div>
	);
}

function CitationAccordion({ title, children, defaultOpen }) {
	const [isOpen, setIsOpen] = useState(defaultOpen);

	return (
		<div className="w-full border border-gray-700 rounded-lg bg-gray-900/20 shadow-lg backdrop-blur-sm overflow-hidden">
			<button
				onClick={() => setIsOpen(!isOpen)}
				className="w-full px-4 py-3 flex items-center justify-between text-left transition-colors cursor-pointer"
				style={{ backgroundColor: '#1A212B' }}
			>
				<span className="text-sm font-normal text-gray-400">{title}</span>
				<svg
					className={`w-4 h-4 text-gray-500 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
					fill="none"
					stroke="currentColor"
					viewBox="0 0 24 24"
				>
					<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
				</svg>
			</button>
			{isOpen && (
				<div className="px-4 pb-4 pt-2 overflow-hidden">
					{children}
				</div>
			)}
		</div>
	);
}
